import { render, staticRenderFns } from "./TourStopsEditor.vue?vue&type=template&id=50edc5f4&scoped=true&"
import script from "./TourStopsEditor.vue?vue&type=script&lang=js&"
export * from "./TourStopsEditor.vue?vue&type=script&lang=js&"
import style0 from "./TourStopsEditor.vue?vue&type=style&index=0&id=50edc5f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50edc5f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
